import { render } from "./PagoServicio.vue?vue&type=template&id=07ede454&scoped=true"
import script from "./PagoServicio.vue?vue&type=script&lang=js"
export * from "./PagoServicio.vue?vue&type=script&lang=js"

import "./PagoServicio.vue?vue&type=style&index=0&id=07ede454&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07ede454"]])

export default __exports__